import { render, staticRenderFns } from "./Rsb.vue?vue&type=template&id=4e55f8a4&scoped=true&"
import script from "./Rsb.vue?vue&type=script&lang=js&"
export * from "./Rsb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55f8a4",
  null
  
)

export default component.exports